module.exports = __webpack_public_path__ + "static/media/KMH_5289.80dbeb95.jpg";